{
  "en": {
    "directUpload": {
      "title": "Upload",
      "chooseFiles": "Choose files",
      "dropzone": {
        "textMultiple": "Drop files here",
        "text": "Drop file here",
        "or": "or",
        "browse": "browse"
      },
      "previewImage": {
        "remove": "Remove"
      },
      "actions": {
        "upload": "Upload",
        "close": "Close"
      }
    }
  }
}
